import theme, { ThemeVariants } from '@theme';
import React from 'react';
import styled from 'styled-components';

import { Icon, IIconName } from '../icon';

interface DisplayFieldValueProps {
  label: string;
  badge?: {
    icon?: IIconName;
    color: ThemeVariants;
    full: boolean;
  };
}

const DisplayFieldValue: React.FC<DisplayFieldValueProps> = ({ label, badge }) => {
  if (badge) {
    const BadgeContainer = badge.full ? BadgeContainerFull : BadgeContainerEmpty;
    return (
      <BadgeContainer color={badge.color}>
        {badge.icon && (
          <IconContainer>
            <CustomIcon iconName={badge.icon.iconName} />
          </IconContainer>
        )}
        {label}
      </BadgeContainer>
    );
  }
  return <DisplayFieldValueContainer>{label}</DisplayFieldValueContainer>;
};

const IconContainer = styled.div`
  width: 0.625rem;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CustomIcon = styled(Icon)`
  width: 0.625rem;
  color: ${theme.palette.red[700]};
  margin-right: 0.125rem;
`;

const BadgeContainerSkeleton = styled.div<{ color: ThemeVariants }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  width: fit-content;
  height: fit-content;
  padding-top: 0.125rem;
  padding-left: 0.25rem;
  padding-bottom: 0.125rem;
  padding-right: 0.375rem;
  border-radius: 0.25rem;
  border-style: solid;
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 500;
  text-align: center;
`;

const BadgeContainerFull = styled(BadgeContainerSkeleton)`
  background-color: ${(props) => {
    return theme.palette[props.color][100];
  }};
  color: ${(props) => {
    return theme.palette[props.color][500];
  }};
  border-width: 0px;
`;

const BadgeContainerEmpty = styled(BadgeContainerSkeleton)`
  border-color: ${(props) => {
    return theme.palette[props.color][200];
  }};
  color: ${(props) => {
    return theme.palette[props.color][600];
  }};
  border-width: 1px;
`;

const DisplayFieldValueContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 0.688rem;
  line-height: 0.938rem;
  font-weight: 500;
  color: ${theme.palette.grey[400]};
`;

export default DisplayFieldValue;
